import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner automotive-back">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="pagehead-title wow fadeInUp">AUTOMOTIVE</h2>
						<div className="red-border"> </div>
						<p>Our automotive solutions help, lower operational costs and enhance performance using our ready-to-deploy technology.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
